import React from "react";
import { Button, Select } from "antd";

const Paginacao = ({ currentPage, pageSize, totalRecords, onPageChange }) => {
  const totalPages = Math.ceil(totalRecords / pageSize);

  if (totalPages === 0) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div style={{ display: "flex", gap: "8px", marginTop: 16, textAlign: "center" }}>
      {/* Botão Anterior */}
      <p className="quantidade-registros-reunioes">Quantidade registro: {totalRecords}</p>
      <Button
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1, pageSize)}
        className="btn-page"
      >
        Anterior
      </Button>

      {/* Números das páginas */}
      {pages.map((page) => (
        <Button
          key={page}
          type={currentPage === page ? "primary" : "default"}
          onClick={() => onPageChange(page, pageSize)}
          className={`btn-page ${currentPage === page ? "active" : ""}`}  
        >
          {page}
        </Button>
      ))}

      {/* Botão Próximo */}
      <Button
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1, pageSize)}
        className="btn-page"
      >
        Próximo
      </Button>

      {/* Select para alterar pageSize */}
      <Select
        value={pageSize}
        onChange={(novoSize) => onPageChange(1, novoSize)} // resetar para página 1 ao mudar pageSize
        style={{ width: 130 }}
        className="custom-select"
      >
        {[5, 10, 20, 50].map((size) => (
          <Select.Option key={size} value={size}>
            {size} / página
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default Paginacao;
